import { Link } from 'gatsby';
import { Nav } from '../nav/nav';
import PropTypes from 'prop-types';
import React from 'react';
import dfesBlack from '../../images/template/icon-dfes-black.png';
import facebookBlack from '../../images/template/icon-facebook-black_1icon-facebook-black.png';
import instagramBlack from '../../images/template/icon-instagram-black_1icon-instagram-black.png';
import linkedInBlack from '../../images/template/icon-linkedin-black_1icon-linkedin-black.png';
import twitterImage from '../../images/template/icon-twitter-black_1icon-twitter-black.png';
import youtubeBlack from '../../images/template/icon-youtube-black_1icon-youtube-black.png';

const Footer = ({ footerClassName }) => (
    <footer className={`site-footer${footerClassName && ' ' + footerClassName}`}>
        <div className="main-section dark">
            <div className="footer-section">
                <div className="w-container">
                    <div className="w-row">
                        <div className="column-8 w-col w-col-6 w-col-tiny-tiny-stack w-col-small-small-stack">
                            <a href="http://dfes.wa.gov.au/" className="w-inline-block" aria-label="Visit our website">
                                <img src={dfesBlack} alt="" />
                            </a>
                        </div>
                        <div className="column-7 w-col w-col-6 w-col-tiny-tiny-stack w-col-small-small-stack">
                            <a
                                href="https://www.facebook.com/dfeswa"
                                target="_blank"
                                className="w-inline-block"
                                aria-label="Visit our Facebook page"
                            >
                                <img src={facebookBlack} alt="" className="image-3" />
                            </a>
                            <a
                                href="https://twitter.com/dfes_wa"
                                target="_blank"
                                className="w-inline-block"
                                aria-label="Visit our Twitter page"
                            >
                                <img src={twitterImage} alt="" className="image-5" />
                            </a>
                            <a
                                href="https://www.youtube.com/dfeswesternaustralia"
                                target="_blank"
                                className="w-inline-block"
                                aria-label="Visit our YouTube page"
                            >
                                <img src={youtubeBlack} alt="" className="image-6" />
                            </a>
                            <a
                                href="https://www.instagram.com/dfes_wa/"
                                target="_blank"
                                className="w-inline-block"
                                aria-label="Visit our Instagram page"
                            >
                                <img src={instagramBlack} alt="" className="image-4" />
                            </a>
                            <a
                                href="https://www.linkedin.com/company/fire-&amp;-emergency-services-authority/"
                                target="_blank"
                                className="w-inline-block"
                                aria-label="Visit our LinkedIn page"
                            >
                                <img src={linkedInBlack} alt="" />
                            </a>
                        </div>
                    </div>
                    <div className="columns-4 w-row footer-section__bottom-row">
                        <div className="column-17">
                            <a href="http://wa.gov.au/">WA.gov.au</a>
                            <a href="https://www.dfes.wa.gov.au/pages/disclaimer.aspx">Disclaimer</a>
                            <a href="https://www.dfes.wa.gov.au/pages/privacy.aspx">Privacy&nbsp;Policy</a>
                            <a href="https://www.dfes.wa.gov.au/pages/foi.aspx">Freedom&nbsp;of&nbsp;Information</a>
                            <a href="https://www.dfes.wa.gov.au/pages/copyright.aspx">Copyright</a>
                            <a href="https://www.dfes.wa.gov.au/pages/accessibility.aspx">Accessibility</a>
                            <a href="https://www.dfes.wa.gov.au/contactus">Contact&nbsp;Us</a>
                        </div>
                        <div>
                            <div className="copyright-text">© Government of Western Australia. All&nbsp;rights&nbsp;reserved.</div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </footer>
);

export default Footer;
